import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTableFooter } from 'src/components/data-table/data-table-footer';
import { useResources } from '../../../hooks';
import { getAppeals } from '../../../thunks/appeal-thunks';
import { DataGrid } from '../../data-grid';
import { Page } from '../../page';
import { AppealsCard } from '../appeals-card';

export const AppealsAdmin: ComponentType = () => {
  const { t } = useTranslation();
  const {
    list: { hits, isLoading, total },
    query,
    handleQueryUpdate,
  } = useResources({
    entity: 'appeal',
    onGetAll: getAppeals,
    defaultParams: { embed: 'user,questions' },
  });

  return (
    <Page title={t('appeals', 'Апелляции')}>
      <DataGrid
        data={hits}
        spacing={3}
        itemProps={{ xs: 4 }}
        isLoading={isLoading}
        renderItem={(item) => <AppealsCard item={item} />}
      />
      <br />
      <DataTableFooter {...{ total, query, onUpdate: handleQueryUpdate }} />
    </Page>
  );
};
